import { render } from "./accordion-component.vue?vue&type=template&id=7b7a38e8"
import script from "./accordion-component.vue?vue&type=script&lang=js"
export * from "./accordion-component.vue?vue&type=script&lang=js"

import exportComponent from "/Users/riccardosirchia/Projects/dryrobe.com-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__